import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class textService {    
  async fetch(params) {
    try {      
      const result = await client.get('text/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async edit(id, obj) {
    try {
      const result = await client.post(`text/edit/${id}`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`text/view/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new textService();
